import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class MovuRobotics_get_location_container_by_nameService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { locationName: string }): 
  Promise<{ result: { Id?: number, IsLoose?: boolean, Name?: string, TypeId?: number, WarehouseId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.locationName)) {
      $missingRequiredInParams.push('\'locationName\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      locationName: string    }) {
        if(isNil($inParams.locationName)) {
          return true; 
        }
      return false;
    }
}
